module.exports = __webpack_public_path__ + "static/media/38-2.bfb71c24.mp3";